function matchHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  elements.forEach(el => {
    el.style.height = 'auto';
  });

  requestAnimationFrame(() => {
    let maxHeight = 0;

    elements.forEach(el => {
      const height = el.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    elements.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  });
}

function initMatchHeight() {
  matchHeight('.productitem--info');
  matchHeight('.productitem--title--link');
  // matchHeight('.article--excerpt-text');
  // matchHeight('.article--excerpt-title');
}

document.addEventListener('DOMContentLoaded', initMatchHeight);
window.addEventListener('load', initMatchHeight);
window.addEventListener('resize', () => {
  clearTimeout(window._mhTimer);
  window._mhTimer = setTimeout(initMatchHeight, 100);
});